import FieldMap from "DashboardBuilder/FieldMap";
import '../styles/Editors.scoped.scss';

export default function SourceSelector({field, sourceSelected}) {
  return <div className="field-editor-row">
    <label className="label">
      Data Source
    </label>
    <div className='field-editor-input'>
      <select
        className="source-selector"
        onChange={(e) => sourceSelected(e.target.value === "" ? null : e.target.value)}
        value={field.source || ''}
      >
        <option key={null} value=''>
          Select a source
        </option>
        {FieldMap.filter(otherFieldOption => !otherFieldOption.hiddenOnSelectedField?.(field)).map((otherFieldOption) => (
          <option key={otherFieldOption.source} value={otherFieldOption.source}>
            {otherFieldOption.label}
          </option>
        ))}
      </select>
    </div>
  </div>
}
